// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-properties-panel[data-v-99bb35da]{width:240px;min-width:240px;padding:12px;overflow-y:auto;border-left:1px solid #e0e0e0;background:#fafafa}.prop-row[data-v-99bb35da]{display:flex;flex-direction:column}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
